"use client";

import { SkeletonLine, SkeletonStack } from "@health/ui";

/**
 * Loading skeleton mirroring TestimonialCard — optional header, 5 star
 * placeholders, an inset quote block, and an author line.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link TestimonialWidget} chunk.
 */
export function TestimonialWidgetSkeleton() {
  return (
    <div className="bg-widget-bg rounded-2xl p-6 shadow-sm w-full">
      <SkeletonStack>
        <SkeletonLine $size="title" $width="md" />
        <div className="flex items-center gap-1">
          {[0, 1, 2, 3, 4].map((i) => (
            <SkeletonLine key={i} $size="caption" $width="xs" className="size-4 rounded-sm" />
          ))}
        </div>
        <div className="bg-secondary/60 rounded-xl p-4 space-y-2">
          <SkeletonLine $size="text" $width="full" />
          <SkeletonLine $size="text" $width="lg" />
          <SkeletonLine $size="text" $width="md" />
        </div>
        <SkeletonLine $size="text" $width="md" />
      </SkeletonStack>
    </div>
  );
}
